import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims.list.component.html'
})
export class ClaimsListComponent {
  
}